import React from 'react';

class HelmetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    if (error?.message?.includes('Helmet expects a string')) {
      console.warn('Helmet title warning suppressed');
    }
  }

  render() {
    return this.props.children;
  }
}

export default HelmetErrorBoundary;
